import React from "react";

/**
 * @component MyWorkIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <MyWorkIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const MyWorkIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="MyWorkIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path d="M12 12a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 110-8 4 4 0 010 8zm-7 5c.4-1.647 1.356-2.88 2.53-3.265A14.25 14.25 0 0112 15c1.49 0 2.98.245 4.47.735C17.645 16.12 18.6 17.353 19 19h-2.085c-.274-.757-.696-1.243-1.068-1.365A12.252 12.252 0 0012 17c-1.275 0-2.555.21-3.847.635-.372.122-.794.608-1.068 1.365H5zM5 4a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V5a1 1 0 00-1-1H5zm0-2h14a3 3 0 013 3v14a3 3 0 01-3 3H5a3 3 0 01-3-3V5a3 3 0 013-3z" />
      <path
        stroke="#F4F5F7"
        strokeWidth={0.1}
        opacity={0.01}
        d="M.05.05h23.9v23.9H.05z"
      />
    </svg>
  )
);
MyWorkIcon.displayName = "MyWorkIcon";
export default MyWorkIcon;
